<template>
  <el-row>
    <table-template :queryParams="queryParams" actionUrl="/businessIntranet/findBusinessDeviceAdminList.action"
                    ref="Table">
      <template slot="search">
        <el-row>
          <el-form :inline="true" >
              <el-form-item>
              <el-date-picker
                  @change="onDateTimeChange"
                  end-placeholder="创建结束日期"
                  range-separator="至"
                  start-placeholder="创建开始日期"
                  type="datetimerange"
                  v-model="queryParams.startEndTime">
              </el-date-picker>
            </el-form-item>

            <el-form-item>
              <el-select  @change="search()" clearable placeholder="排序" v-model="queryParams.sortType">
                <el-option :value="1" label="分享次数从小到大"></el-option>
                <el-option :value="2" label="分享车源数从小到大"></el-option>
                <el-option :value="3" label="分享群数从小到大"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item>
                <el-input style="width: 200px" placeholder="搜索设备编号、账号" v-model="queryParams.keyword"></el-input>
               <el-button @click="search()" type="warning">搜索</el-button>
            </el-form-item>
          </el-form>
        </el-row>
          <row>
              <el-col :span="6" >
                  <span style="font-size: 18px;color: red;">
                      当前查询结果：{{deviceData.groupNameCount}}个不重复群
                  </span>
              </el-col>
            <el-col :span="12">
                  <span style="font-size: 18px;color: red;">
                      {{deviceData.currentShareTotal}}次分享次数（相比前一日{{deviceData.growthRate}}）
                  </span>
              </el-col>
          </row>

      </template>
      <template slot="item">

        <el-table-column
            label="设备编号"
            width="200px"
        >
          <template slot-scope="scope">
            <p>{{ scope.row.deviceName }}</p>

          </template>
        </el-table-column>
        <el-table-column
            label="登录账号(内网)"
        >
          <template slot-scope="scope">
            <p>{{scope.row.phone}}- {{scope.row.businessName}}</p>
          </template>
        </el-table-column>

        <el-table-column
                label="分享次数"

        >
          <template slot-scope="scope">
            <p>{{scope.row.shareCount}}</p>
          </template>
        </el-table-column>
        <el-table-column
            label="同步朋友圈(条)"
        >
          <template slot-scope="scope">
            <p>{{scope.row.friendCount}}</p>
          </template>
        </el-table-column>
        <el-table-column
                label="分享车源数(去重)"

        >
          <template slot-scope="scope">
            <p>{{scope.row.shareModuleCount}}</p>
          </template>
        </el-table-column>

        <el-table-column
                label="分享群数(去重)"

        >
          <template slot-scope="scope">
            <p>{{scope.row.shareGroupNameCount}}</p>
          </template>
        </el-table-column>

       <!-- <el-table-column
                label="邀请注册"
        >
          <template slot-scope="scope">
            <p>{{scope.row.inviteBusPhoneCount}}</p>
          </template>
        </el-table-column>-->

          <el-table-column
                  label="最近分享时间"
                  width="180px">
              <template slot-scope="scope">
                  {{ scope.row.maxCreateTime  }}
              </template>
          </el-table-column>
        <el-table-column
                label="最近App更新时间"
                width="180px">
          <template slot-scope="scope">
            {{ scope.row.maxAppVersion  }}
          </template>
        </el-table-column>

        <el-table-column
            label="操作"
            width="120px"
        >
            <template scope="scope">
                <el-button type="text" @click="$router.push({path:'/home/intranetDeviceRecord',query:{keyword:scope.row.deviceName}})">查看数据</el-button>
            </template>
        </el-table-column>

      </template>
    </table-template>
  </el-row>
</template>

<script>
import TableTemplate from '@/components/TableTemplate'
import BasicPager from '@/mixins/BasicPager'
import DateUtil from '@/framework/utils/DateUtil'
import BasicModel from '@/framework/basic/BasicModel'

export default {
  components: {
    TableTemplate
  },
  extends: BasicPager,
  name: 'deviceIntranetManagement',
  data: function () {
    return {
      queryParams: {
        sortType: null,
        startEndTime: [],
        startTime: null,
        endTime: null,
        keyword: null
      },
      deviceData: {
        shareGroupNameCount: 0
      }
    }
  },
  activated: function () {
    this.$refs.Table.search()
  },
  created: function () {
    this.queryParams.startTime = DateUtil.getDayStartTime().getTime()
    this.queryParams.endTime = DateUtil.getDayEndTime().getTime()
    this.queryParams.startEndTime = [DateUtil.getDayStartTime(), DateUtil.getDayEndTime()]
    this.loadData()
  },
  watch: {

  },
  methods: {
    loadData () {
      let _this = this
      let listener = {
        success: function (dataInfo) {
          if (dataInfo.datas) {
            _this.deviceData = dataInfo.datas
          } else {
            _this.deviceData.shareGroupNameCount = 0
          }
        }
      }
      BasicModel.get(this, 'businessIntranet/selectBusinessDeviceStatic.action', this.queryParams, listener)
    },
    search: function () {
      this.$refs.Table.search()
      this.loadData()
    },
    onDateTimeChange (dates) {
      if (dates && dates.length === 2) {
        this.queryParams.startTime = dates[0].getTime()
        this.queryParams.endTime = dates[1].getTime()
      } else {
        this.queryParams.startTime = null
        this.queryParams.endTime = null
      }
      this.search()
    }
  },
  filters: {

  }
}
</script>

<style scoped>
</style>
